import requestServer from "../request-server";

var internals = {};

internals.termsAndCondition = function (data) {
  return requestServer({
    endPoint: "termsAndCondition",
    data,
    method: "POST",
    contentType: "application/json; charset=utf-8",
    auth: 'system'
  });
};

export default internals;
